(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();

        const data = new FormData(form);
        data.set('return_to', '/checkout');

        fetch('/cart/add.js', {
          method: 'POST',
          body: data
        }).then(() => {
          window.location.href = '/checkout';
        });
      }, true);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
